import React from 'react';

export const Search = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M22.5692 22.72L27.2 27.2M25.7067 15.2534C25.7067 21.0266 21.0266 25.7067 15.2534 25.7067C9.48017 25.7067 4.80005 21.0266 4.80005 15.2534C4.80005 9.48017 9.48017 4.80005 15.2534 4.80005C21.0266 4.80005 25.7067 9.48017 25.7067 15.2534Z"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);
